// extracted by mini-css-extract-plugin
export default {"loading_overlay":"loading_loading_overlay__+DNQn","spinner":"loading_spinner__-+7IQ","spin":"loading_spin__OW+R2"};